import { Component, NgModuleRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutCostCenterFacade } from '@spartacus/checkout/b2b/root';
import { CheckoutStepService, CheckoutDeliveryAddressComponent } from '@spartacus/checkout/base/components';
import { CheckoutDeliveryAddressFacade, CheckoutDeliveryModesFacade } from '@spartacus/checkout/base/root';
import { Address, GlobalMessageService, QueryState, RoutingService, TranslationService, UserAddressService, UserCostCenterService, TranslatePipe } from '@spartacus/core';
import { Card, LaunchDialogService, CardComponent, SpinnerComponent } from '@spartacus/storefront';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { KnBrAddress } from 'src/app/models/kn-br-order.model';
import { KnBrAddressFormComponent } from './../../kn-br-customer360/kn-br-address-book/kn-br-address-form/kn-br-address-form.component';
import { KnBrAddressService } from './../../store/kn-br-address/kn-br-address.service';
import { AsyncPipe } from '@angular/common';
import { OrderByPipe } from '../../shared/pipe/order-by.pipe';
// Need to Discuss
@Component({
    selector: 'cx-shipping-address',
    templateUrl: './kn-br-shipping-address.component.html',
    styleUrls: ['./kn-br-shipping-address.component.scss'],
    imports: [CardComponent, SpinnerComponent, AsyncPipe, TranslatePipe, OrderByPipe]
})
export class KnBrShippingAddressComponent extends CheckoutDeliveryAddressComponent implements OnInit {
  subscription = new Subscription();
  isAccountPayment: boolean;
  constructor(
    protected userAddressService: UserAddressService,
    protected routingService: RoutingService,
    protected checkoutDeliveryService: CheckoutDeliveryAddressFacade,
    protected checkoutDeliveryComponents: CheckoutDeliveryAddressComponent,
    protected activatedRoute: ActivatedRoute,
    protected translation: TranslationService,
    protected activeCartService: ActiveCartFacade,
    protected checkoutStepService: CheckoutStepService,
    protected modalService: NgbModal,
    protected knBrAddressService: KnBrAddressService,
    protected globalMessageService: GlobalMessageService,
    protected checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
    protected userCostCenterService?: UserCostCenterService,
    protected checkoutCostCenterService?: CheckoutCostCenterFacade
  ) {
    super(
      userAddressService,
      checkoutDeliveryService,
      activatedRoute,
      translation,
      activeCartService,
      checkoutStepService,
      checkoutDeliveryModesFacade,
      globalMessageService
    );
    this.knBrAddressService.oneTimeAddress$.subscribe((oneTimeAddress) => {
      this.userAddressService.getAddresses();
    });
  }

  get deliveryAddress$() {
    return this.checkoutDeliveryService.getDeliveryAddressState();
  }
  get getOtshAddress() {
    const OtshAddress: any = {};
    this.checkoutDeliveryService.getDeliveryAddressState().subscribe((address) => {
      OtshAddress.address = address;
      OtshAddress.card = this.getCardContent(OtshAddress.address, { id: address.data.id }, '', '', 'Selected');
    });
    return OtshAddress;
  }

  ngOnInit(): void {
    // super.ngOnInit();
    this.isAccountPayment = false;
    this.userAddressService.loadAddresses();
  }

  goToCartDetail() {
    this.activeCartService
      .getActiveCartId()
      .subscribe((cartId) => {
        this.routingService.go({ cxRoute: 'cartDetails', params: { code: cartId } });
      })
      .unsubscribe();
  }

  openAddressForm() {
    let modalInstance: any;
    const modalRef = this.modalService.open(KnBrAddressFormComponent, {
      centered: true,
      size: 'lg',
    });
    modalInstance = modalRef.componentInstance;
    modalInstance.isCheckOut = true;
    modalInstance.showCancelBtn = true;
    modalRef.result
      .then((address) => {
        if (address && address.isOneTime) {
          const onetimeaddress = {
            ...address.address,
            isDisposable: true,
          };
          this.knBrAddressService.createOneTimeAddress(onetimeaddress);
        } else {
          this.addAddress(address.address);
        }
      })
      .catch((error) => {});
  }

  getCardContent(
    address: KnBrAddress,
    selected: any,
    textDefaultShippingAddress: string,
    textShipToThisAddress: string,
    textSelected: string
  ): Card {
    let region = '';
    if (address.region && address.region.isocode) {
      region = address.region.isocode;
    }

    return {
      title: address.defaultAddress ? textDefaultShippingAddress : '',
      textBold: address.firstName + (address.lastName ? ' ' + address.lastName : ''),
      text: [
        (address.houseNumber ? address.houseNumber + ', ' : '') + address.line1,
        address.line2,
        address.town + ', ' + region,
        address.country.isocode + ', ' + address.postalCode,
        this.formatPhone(address.phone)
      ],
      actions: [{ name: textShipToThisAddress, event: 'send' }],
      header: selected && selected.id === address.id ? textSelected : '',
    };
  }

  formatPhone(value) {
    const trim = value?.substring(2);
    const cleaned = ('' + trim).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    } else {
      const removeSpaces = value?.replace(/\s/g, '');
      const trim = removeSpaces?.substring(1);
      const match = trim?.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }
    }
  }
}
